import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@core/services/api/auth.service';
import { ViewportService } from '@core/services/viewport.service';
import { resolveDefaultLandingRoute } from '@shared/utils/default-landing-route';
import { rememberRedirectIntent } from '@shared/utils/redirect-intent';
import { RoleLevel } from '@shared/models/role.enum';
import { resolveReturnUrl } from '@shared/utils/return-url';

export const minRoleGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const viewport = inject(ViewportService);

  const requiredRoleValue =
    (route.data?.['minRole'] as number | undefined) ?? RoleLevel.Member;
  const fallbackRoute = resolveDefaultLandingRoute(auth.getRoleValue());

  if (!auth.isAuthenticated()) {
    const returnUrl = resolveReturnUrl(state.url, fallbackRoute);
    rememberRedirectIntent(returnUrl);

    // Mobile login lives at `/login` (distinct view-stack key from the
    // tabs-shell parent route at `path: ''`). Desktop login lives at `/`.
    // Sending a mobile user to `/` would just hit the mobile root redirect
    // back to `/login`, but routing direct avoids the extra hop.
    const loginPath = viewport.isMobile() ? '/login' : '/';

    return router.createUrlTree([loginPath], {
      queryParams: { returnUrl },
    });
  }

  const userRoleValue = auth.getRoleValue();
  if (userRoleValue >= requiredRoleValue) return true;

  return router.createUrlTree(['/forbidden'], {
    queryParams: { returnUrl: resolveReturnUrl(state.url, fallbackRoute) },
  });
};

